import { useState } from 'react';
import { CloseButton } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { NotificationBar } from '~/types/NotificationBar';
import { setCookie } from '~/utils/cookies.client';

type Props = {
  content: NotificationBar | null;
};

const NotificationBanner = ({ content }: Props) => {
  const [visible, setVisible] = useState(true);
  const { t } = useTranslation();

  if (!content || !visible) return null;

  const handleClick = () => {
    setCookie('notification_banner_closed', 'true', { maxAge: 31536000 });
    setVisible(false);
  };

  return (
    <div className="notification-banner" style={{ backgroundColor: content.color }}>
      <div className="notification-banner__content text-center container position-relative">
        {content.text}
        <CloseButton
          variant="white"
          className="notification-banner__close position-absolute"
          onClick={handleClick}
          aria-label={t('close_banner')}
        />
      </div>
    </div>
  );
};

export default NotificationBanner;
